import { usePageBreakpoint } from "@@/shared/responsiveness/use-page-breakpoint";
import { SectionArea } from "@@/shared/section-area";
import { SimpleGrid } from "@@/shared/simple-grid";
import { useProductIdWithFallback } from "@@/store-fronts/shared/fallback-product-ids";
import { OneSquareSection } from "@@/store-fronts/shared/one-square-section";
import { useTheme } from "@emotion/react";
import type { ProductId} from "@towni/common";
import { translation } from "@towni/common";
import * as React from "react";
import type { FC } from "react";

const BauerAdventuresSection: FC = () => {
    const getProductId = useProductIdWithFallback();
    const theme = useTheme();
    const _isDesktop = usePageBreakpoint({ when: "🖥" });

    const canoe = React.useMemo(
        () => getProductId("product__xx6uhSbuXXAVCIzN7WRg" as ProductId),
        []
    );
    const rowboat = React.useMemo(
        () => getProductId("product__yg7nGBQKnZez2Z5sLioI" as ProductId),
        []
    );
    const mtb = React.useMemo(
        () => getProductId("product__CEdP6NXTMN3AGfsK4Pez" as ProductId),
        []
    );
    const cycle = React.useMemo(
        () => getProductId("product__b8W3kk8KZaNNg4u4qdjW" as ProductId),
        []
    );
    const productIds = [canoe, rowboat, mtb, cycle];

    return (
        <SectionArea
            title={translation({
                sv: "Ut på äventyr",
                en: "Going on an adventure",
            })}
            subtitle={translation({
                sv: "Här runt Bunn finns något för alla. Vandra, paddla och cykla i Bauers trolska miljön, träna på vårt utomhusgym eller koppla av i vår underbara sjöstuga med bastu nere vid sjön.",
                en: "",
            })}
            sectionAreaId="bauer-adventure-4-section"
            //crossAxis="center"
            padding={{ top: 0 }}>
            <SimpleGrid size={"XL"} padding={{ leftRight: 20, bottom: 10 }}>
                {productIds.map((id, index) => {
                    return (
                        <OneSquareSection
                            key={id}
                            productId={id}
                            aspectRatio={"1:1"}
                            contentTop={index === 3 ? true : index % 2 === 0}
                            actionText={
                                index >= actionTexts.length
                                    ? actionTexts[0]
                                    : actionTexts[index]
                            }
                            hideKicker
                            colorSet={theme.colors.primary}
                        />
                    );
                })}
            </SimpleGrid>
        </SectionArea>
    );
};

const text = {
    book: translation({
        sv: "Boka",
        en: "Book",
    }),
    explore: translation({
        sv: "Upplev",
        en: "Book",
    }),
    seeTime: translation({
        sv: "Se & Boka",
        en: "Book",
    }),
};

const actionTexts = [text.book, text.explore, text.seeTime];

export { BauerAdventuresSection };
